"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var InteractiveImage =
/** @class */
function (_super) {
  __extends(InteractiveImage, _super);

  function InteractiveImage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      reveal: false
    };

    _this.imagePressHandler = function () {
      _this.setState(function (prevState) {
        return {
          reveal: !prevState.reveal
        };
      });
    };

    return _this;
  }

  InteractiveImage.prototype.render = function () {
    var _a = this.props,
        infoText = _a.infoText,
        revealedText = _a.revealedText,
        activeBreakpoint = _a.activeBreakpoint;
    var reveal = this.state.reveal;
    var images = components_lib_1.appConfig.images;
    var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
    var imageUri = extraLarge ? images.addOnsModulesOwlThought : images.mascot;
    return react_1.default.createElement(components_lib_1.RowCenteredResponsive, null, react_1.default.createElement(Details, {
      extraLarge: extraLarge
    }, react_1.default.createElement(DetailsText, null, reveal ? revealedText : infoText)), react_1.default.createElement(react_native_1.TouchableWithoutFeedback, {
      onPress: this.imagePressHandler
    }, react_1.default.createElement(ClickableImage, {
      source: {
        uri: imageUri
      },
      extraLarge: extraLarge
    })));
  };

  return InteractiveImage;
}(react_1.Component);

var ClickableImage = styled_components_1.default(function (_a) {
  var extraLarge = _a.extraLarge,
      rest = __rest(_a, ["extraLarge"]);

  return react_1.default.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var extraLarge = _a.extraLarge;
  return "\n            width: " + (!extraLarge ? 110 : 141) + "px;\n            height: " + (!extraLarge ? 100 : 96) + "px;\n        ";
});
var Details = styled_components_1.default(function (_a) {
  var extraLarge = _a.extraLarge,
      rest = __rest(_a, ["extraLarge"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    overflow: auto\n    max-width: 320px;\n    max-height: 110px;\n    margin-right: 4px;\n    padding: 12px;\n    background: #fff;\n    border-radius: 12px;\n    ", "\n"], ["\n    ", "\n    overflow: auto\n    max-width: 320px;\n    max-height: 110px;\n    margin-right: 4px;\n    padding: 12px;\n    background: #fff;\n    border-radius: 12px;\n    ", "\n"])), function (_a) {
  var extraLarge = _a.extraLarge;
  return "\n            margin-bottom: " + (!extraLarge ? 24 : -10) + "px;\n        ";
}, components_lib_1.customScrollbar);
var DetailsText = styled_components_1.default(react_native_1.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 14px;\n    color: ", ";\n"], ["\n    font-size: 14px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colorVariations.purple.alpha120;
});
exports.default = responsive_1.withResponsiveMeta(InteractiveImage);
var templateObject_1, templateObject_2, templateObject_3;